import React from "react"

const SectionEight = () => {
  return (
    <div className="text-center h-40vw relative mobiles:top-96 z-0 footer-bg pb-20"></div>
  )
}

export default SectionEight
